import PropTypes from 'prop-types';
import PjaxWrapper from '../../utils/PjaxWrapper';
import ReloadHelper from '../../utils/ReloadHelper';
import NavBarNewIcon from './NavBarNewIcon';
import { Component } from 'react';

class NavBarTabletDropdownElementSubItem extends Component {
	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		if (this.props.scrollToTop) {
			PjaxWrapper.setTemporaryScrollToTop();
		}

		ReloadHelper.reloadWithPjax(this.props.link, e);
	}

	render() {
		let icon = '';
		if (this.props.iconClass) {
			const iconClass = this.props.iconClass + ' navbar-tablet__dropdown-icons';
			icon = <i className={iconClass} />;
		}

		return (
			<li className="navbar-tablet__dropdown-subitem h-float-none">
				<a className="navbar-tablet__dropdown-sublink" onClick={this.onClick} href={this.props.link}>
					{icon}
					{this.props.caption}
					{this.props.isNew && <NavBarNewIcon isTablet={true} />}
				</a>
			</li>
		);
	}
}

NavBarTabletDropdownElementSubItem.propTypes = {
	caption: PropTypes.string,
	iconClass: PropTypes.string,
	isNew: PropTypes.bool,
	link: PropTypes.string,
	scrollToTop: PropTypes.bool,
};

NavBarTabletDropdownElementSubItem.defaultProps = {
	iconClass: '',
	isNew: false,
	scrollToTop: false,
};

export default NavBarTabletDropdownElementSubItem;
